/* Formes de séparation (snippets/forme-separation.liquid) : chaque forme « auto » se peint
   dans la couleur de fond de la section voisine. ES5, déclaré une seule fois (window.__formeSep).
   Une seule passe groupée par image : toutes les lectures (sections visibles, fonds), puis toutes
   les écritures (couleur des formes). Rien pendant l'analyse du HTML : première passe au
   DOMContentLoaded, puis au chargement complet, au redimensionnement (après 200 ms de calme)
   et aux changements de l'éditeur. Avant la première passe, la feuille de style cache la forme. */
(function () {
  if (window.__formeSep) return;
  var raf = window.requestAnimationFrame ? function (f) { return window.requestAnimationFrame(f); } : function (f) { return setTimeout(f, 16); };
  function fond(el) {
    if (!el) return null;
    var c = getComputedStyle(el).backgroundColor;
    if (!c || c === 'transparent' || /,\s*0\)$/.test(c)) return null;
    return c;
  }
  function fondSection(s) {
    var c = fond(s.querySelector('.section-background')) || fond(s);
    var e = s.firstElementChild, n = 0;
    while (!c && e && n < 4) { c = fond(e); e = e.firstElementChild; n++; }
    return c;
  }
  var prevu = false;
  function calculer() {
    prevu = false;
    var formes = document.querySelectorAll('.fs[data-fs-auto]');
    if (!formes.length) return;
    /* lectures */
    var toutes = Array.prototype.filter.call(document.querySelectorAll('.shopify-section'), function (s) {
      return s.offsetHeight > 0 && getComputedStyle(s).position !== 'fixed';
    });
    var couleurs = Array.prototype.map.call(formes, function (el) {
      var s = el.closest('.shopify-section');
      var i = toutes.indexOf(s);
      var v = i < 0 ? null : toutes[el.classList.contains('fs--haut') ? i - 1 : i + 1];
      return (v && fondSection(v)) || fond(document.body) || fond(document.documentElement) || '#fff';
    });
    /* écritures */
    Array.prototype.forEach.call(formes, function (el, k) {
      if (el.style.color !== couleurs[k]) el.style.color = couleurs[k];
    });
  }
  function maj() {
    if (prevu) return;
    prevu = true;
    raf(calculer);
  }
  window.__formeSep = maj;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
  window.addEventListener('load', maj);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(maj, 200); });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(maj, 60); });
  });
})();
